module.exports = __webpack_public_path__ + "static/img/054.9ceec40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/054.png
// module id = ZoD8
// module chunks = 0